import { createSlice, PayloadAction } from '@reduxjs/toolkit'


interface callerState {
  value: boolean,
  userName: string,
  userPhone: string,
  enableEndCallPopUp: boolean,
  endCallData: any,
  callDirection: string,
  phoneNumberForCreateLead: string,
  callerTreatment: any,
  lastTreatment: any, // Store the last treatment details
  typeEndOfCall: number,
  messageEndOfCall: string,

  loadTreatmentToQueue: boolean, // Flag to indicate if treatment should be loaded to queue
}

const initialState: callerState = {
  value: false,
  userName: '',
  userPhone: '',
  enableEndCallPopUp: false,
  endCallData: null,
  callDirection: '',
  phoneNumberForCreateLead: '',
  callerTreatment: null,
  lastTreatment: null, // Store the last treatment details
  typeEndOfCall: 0,
  messageEndOfCall: '',
  loadTreatmentToQueue: false, // Initialize the flag to false
}


export const callerSlice = createSlice({
  name: 'caller',
  initialState,
  reducers: {
    startCall: (state) => {
      state.value = true
    },
    endCall: (state) => {
      state.value = false
    },
    setUserData: (state, { payload }) => {
      state.value = true
      state.userName = payload.userName;
      state.userPhone = payload.userPhone;
    },
    showEndCallPopUp: (state, { payload }) => {
      state.enableEndCallPopUp = payload.show;
      state.endCallData = payload.data;
      //console.log('SignalR showEndCallPopUp', payload.show)
    },
    hideEndCallPopUp: (state) => {
      state.enableEndCallPopUp = false;
    },
    setCallDirection: (state, { payload }) => {
      state.callDirection = payload.direction;
    },
    setPhoneNumberForCreateLead: (state, { payload }) => {
      state.phoneNumberForCreateLead = payload.phoneNumber;
    },
    setCallerTreatment: (state, { payload }) => {
      state.callerTreatment = payload.treatment; // Store treatment details related to the call
    },
    setLastTreatment: (state, action: PayloadAction<any>) => {
      state.lastTreatment = action.payload; // Store the last treatment details
    },
    setTypeEndOfCall: (state, { payload }) => {
      state.typeEndOfCall = payload.type; // Set the type of end of call
    },
    setMessageEndOfCall: (state, { payload }) => {
      state.messageEndOfCall = payload.message; // Set the message for end of call
    },
    setLoadTreatmentToQueue: (state, { payload }) => {
      state.loadTreatmentToQueue = payload.load; // Set the flag to load treatment to queue
    }
  },
})
export const { startCall, endCall, setUserData, showEndCallPopUp, hideEndCallPopUp, setCallDirection, setPhoneNumberForCreateLead, setCallerTreatment ,
   setLastTreatment, setTypeEndOfCall, setMessageEndOfCall,  setLoadTreatmentToQueue} = callerSlice.actions
export default callerSlice.reducer